import {reqWithToken} from './requestHelper';

export async function getTeachersWithKey(key){
    return (await reqWithToken('api/teachers',{
        params:{
            key
        }
    })).data;
}